import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import NotFound from '../../views/notFound';
import ErrorPage from '../../views/errorPage';
import linkResolver, { isApartment, isApplication, isSpecialApartment, isSpecialApplication } from '../../helpers/linkResolver/linkResolver';

const pageWrapper = Component => (props) => {
	const {
		page,
		match,
		error404,
		error500,
		...rest
	} = props;
	if(error404) return <NotFound />;
	if(error500) return <ErrorPage />;

	// At a certain point during route transitions a route or a page will want
	// to render itself in without being the one we're showing the user.
	// This can happen if FETCH_PAGE_FULFILLED has fired before the old
	// view has had a change to animate out.
	// This can also happen if we're animating in the new route but haven't yet received
	// the route from the server
	// In any case, if the global page object we hold does not match this components matched url,
	// we do not render it in
	return (
		page.Url === linkResolver(match.url)
			|| (isApartment(page.Url) && isApartment(match.url))
			|| (isApplication(page.Url) && isApplication(match.url)) 
			|| (isApplication(page.Url) && isSpecialApplication(match.url))
			|| (isApartment(page.Url) && isSpecialApartment(match.url)) ? (
				<Component page={page} match={match} {...rest} />
			) : null
	);
};

const mapStateToProps = ({ pageReducer }) => ({
	page: pageReducer.page,
	error404: pageReducer.error404,
	error500: pageReducer.error500
});

const composedPageWrapper = compose(
	connect(mapStateToProps, null),
	pageWrapper
);

export default composedPageWrapper;
